import { StyledButton } from './button.styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Tooltip';

type BaseProps = Parameters<typeof StyledButton>[0];

interface Props {
  isLoading?: boolean;
  tooltip?: string;
  'data-cy'?: string;
}

export type ButtonProps = Props & BaseProps;

const Button: React.FC<ButtonProps> = ({
  isLoading,
  tooltip,
  'data-cy': dataCy,
  ...p
}) => {
  const { t } = useTranslation('button');
  const buttonContent = useMemo(
    () => (
      <StyledButton
        data-cy={dataCy}
        variant="contained"
        color="primary"
        {...p}
        disabled={isLoading ? true : p['disabled']}
        children={isLoading ? t('loading') : p['children']}
      />
    ),
    [p, t, isLoading]
  );
  return tooltip ? (
    <Tooltip title={tooltip || ''}>
      <span tooltip-data-cy={`tooltip-${dataCy}`}>{buttonContent}</span>
    </Tooltip>
  ) : (
    buttonContent
  );
};

export default Button;
